"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ThumbnailUrlConfig = _interopRequireDefault(require("customer-data-email/schema/attachments/ThumbnailUrlConfig"));

var _HubAPI = require("crm_data/api/HubAPI");

var getPreviewUrl = function getPreviewUrl(fileId) {
  return "/file-preview/" + _hubspot.default.get() + "/file/" + fileId + "/";
};

var _default = new _ThumbnailUrlConfig.default({
  apiDomain: _HubAPI.API_DOMAIN,
  portalId: _hubspot.default.get(),
  getPreviewUrl: getPreviewUrl
});

exports.default = _default;
module.exports = exports.default;